module.exports = __webpack_public_path__ + "static/img/cover.9212342d.jpg";